// Copyright (c) 2020 Deere & Company

import reports from './reports';
import wip from './wip';

export default {
    childRoutes: [
        reports,
        wip
    ],
    indexRoute: {
        onEnter: (nextState, replace) => replace('/tabm/wip')
    },
    name: 'TABM',
    path: 'tabm'
};



// WEBPACK FOOTER //
// ./src/routes/tabm/index.js